import requests from "./httpServices.js";

class RewardService {
  async getBalance() {
    try {
      return await requests.get('/rewards/balance');
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async getTransactions(limit = 20) {
    try {
      return await requests.get(`/rewards/transactions?limit=${limit}`);
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async earnTokens(data) {
    try {
      return await requests.post('/rewards/earn', data);
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async getConfig() {
    try {
      return await requests.get('/rewards/config');
    } catch (error) {
      throw this.handleError(error);
    }
  }

  handleError(error) {
    if (error.response) {
      return new Error(error.response.data?.message || 'Reward service error');
    }
    return error;
  }
}

const rewardService = new RewardService();
export default rewardService;
